import { actions, actionsSelected, actionsSelectedDisabled, groupRow, groupRowCollapsible, groupRowCollapsedIcon, groupRowExpandedIcon, groupTitleContainer, itemContainerSelected, inputContainer, inputContainerSelected, inputContainerSelectedDisabled, inputGroupContainer, inputGroupContainerSelected, inputGroupContainerSelectedDisabled, input, inputDisabled, item, itemContainer, itemContainerDisabled, itemSelected, itemSelectedDisabled, list, } from '../styles';
import { actions as actionsCitrus2022, actionsSelected as actionsSelectedCitrus2022, actionsSelectedDisabled as actionsSelectedDisabledCitrus2022, groupRow as groupRowCitrus2022, groupRowCollapsible as groupRowCollapsibleCitrus2022, groupRowCollapsedIcon as groupRowCollapsedIconCitrus2022, groupRowExpandedIcon as groupRowExpandedIconCitrus2022, groupTitleContainer as groupTitleContainerCitrus2022, itemContainerSelected as itemContainerSelectedCitrus2022, input as inputCitrus2022, inputDisabled as inputDisabledCitrus2022, inputContainer as inputContainerCitrus2022, inputContainerSelected as inputContainerSelectedCitrus2022, inputContainerSelectedDisabled as inputContainerSelectedDisabledCitrus2022, inputGroupContainer as inputGroupContainerCitrus2022, inputGroupContainerSelected as inputGroupContainerSelectedCitrus2022, inputGroupContainerSelectedDisabled as inputGroupContainerSelectedDisabledCitrus2022, item as itemCitrus2022, itemContainer as itemContainerCitrus2022, itemContainerDisabled as itemContainerDisabledCitrus2022, itemSelected as itemSelectedCitrus2022, itemSelectedDisabled as itemSelectedDisabledCitrus2022, list as listCitrus2022, } from '../styles/citron';
import { citrusStyled } from '@citrus/runtime';
export var List = citrusStyled.div('list', { legacy: list, citrus2022: listCitrus2022 });
export var Group = citrusStyled.div('N/A', null);
export var GroupRow = citrusStyled.div('groupRow', { legacy: groupRow, citrus2022: groupRowCitrus2022 });
export var GroupRowCollapsible = citrusStyled.div('groupRowCollapsible', {
    legacy: groupRowCollapsible,
    citrus2022: groupRowCollapsibleCitrus2022,
});
export var GroupRowCollapsedIcon = citrusStyled.div('groupRowCollapsedIcon', {
    legacy: groupRowCollapsedIcon,
    citrus2022: groupRowCollapsedIconCitrus2022,
});
export var GroupRowExpandedIcon = citrusStyled.div('groupRowExpandedIcon', {
    legacy: groupRowExpandedIcon,
    citrus2022: groupRowExpandedIconCitrus2022,
});
export var GroupTitleContainer = citrusStyled.div('groupTitleContainer', {
    legacy: groupTitleContainer,
    citrus2022: groupTitleContainerCitrus2022,
});
export var Actions = citrusStyled.div('actions', { legacy: actions, citrus2022: actionsCitrus2022 });
export var ActionsSelected = citrusStyled.div('actionsSelected', {
    legacy: actionsSelected,
    citrus2022: actionsSelectedCitrus2022,
});
export var ActionsSelectedDisabled = citrusStyled.div('actionsSelectedDisabled', {
    legacy: actionsSelectedDisabled,
    citrus2022: actionsSelectedDisabledCitrus2022,
});
export var Item = citrusStyled.div('item', { legacy: item, citrus2022: itemCitrus2022 });
export var ItemContainer = citrusStyled.div('itemContainer', {
    legacy: itemContainer,
    citrus2022: itemContainerCitrus2022,
});
export var ItemContainerDisabled = citrusStyled.div('itemContainerDisabled', {
    legacy: itemContainerDisabled,
    citrus2022: itemContainerDisabledCitrus2022,
});
export var ItemContainerSelected = citrusStyled.div('itemContainerSelected', {
    legacy: itemContainerSelected,
    citrus2022: itemContainerSelectedCitrus2022,
});
export var ItemSelected = citrusStyled.div('itemSelected', {
    legacy: itemSelected,
    citrus2022: itemSelectedCitrus2022,
});
export var ItemSelectedDisabled = citrusStyled.div('itemSelectedDisabled', {
    legacy: itemSelectedDisabled,
    citrus2022: itemSelectedDisabledCitrus2022,
});
export var Input = citrusStyled.input('input', { legacy: input, citrus2022: inputCitrus2022 });
export var InputDisabled = citrusStyled.input('inputDisabled', {
    legacy: inputDisabled,
    citrus2022: inputDisabledCitrus2022,
});
export var InputContainer = citrusStyled.div('inputContainer', {
    legacy: inputContainer,
    citrus2022: inputContainerCitrus2022,
});
export var InputContainerSelected = citrusStyled.div('inputContainerSelected', {
    legacy: inputContainerSelected,
    citrus2022: inputContainerSelectedCitrus2022,
});
export var InputContainerSelectedDisabled = citrusStyled.div('inputContainerSelectedDisabled', {
    legacy: inputContainerSelectedDisabled,
    citrus2022: inputContainerSelectedDisabledCitrus2022,
});
export var InputGroupContainer = citrusStyled.div('inputGroupContainer', {
    legacy: inputGroupContainer,
    citrus2022: inputGroupContainerCitrus2022,
});
export var InputGroupContainerSelected = citrusStyled.div('inputGroupContainerSelected', {
    legacy: inputGroupContainerSelected,
    citrus2022: inputGroupContainerSelectedCitrus2022,
});
export var InputGroupContainerSelectedDisabled = citrusStyled.div('inputGroupContainerSelectedDisabled', {
    legacy: inputGroupContainerSelectedDisabled,
    citrus2022: inputGroupContainerSelectedDisabledCitrus2022,
});
export var Styled = {
    Actions: Actions,
    ActionsSelected: ActionsSelected,
    ActionsSelectedDisabled: ActionsSelectedDisabled,
    Group: Group,
    GroupRow: GroupRow,
    GroupRowCollapsible: GroupRowCollapsible,
    GroupRowCollapsedIcon: GroupRowCollapsedIcon,
    GroupRowExpandedIcon: GroupRowExpandedIcon,
    GroupTitleContainer: GroupTitleContainer,
    Input: Input,
    ItemContainerDisabled: ItemContainerDisabled,
    InputContainer: InputContainer,
    InputContainerSelected: InputContainerSelected,
    InputContainerSelectedDisabled: InputContainerSelectedDisabled,
    InputGroupContainer: InputGroupContainer,
    InputGroupContainerSelected: InputGroupContainerSelected,
    InputGroupContainerSelectedDisabled: InputGroupContainerSelectedDisabled,
    InputDisabled: InputDisabled,
    Item: Item,
    ItemContainer: ItemContainer,
    ItemContainerSelected: ItemContainerSelected,
    ItemSelected: ItemSelected,
    ItemSelectedDisabled: ItemSelectedDisabled,
    List: List,
};
